export default "__VITE_ASSET__DRpyHNck__"